export default {
    "AdditionalPageTypes": true,
    "Admin": true,
    "Advertising": false,
    "Advertising2": {
        adServers: ["simple", "adition"],
        adSizes: ["mpu", "banner"]
    },
    "AggregatedContentFeed": true,
    "AllowCustomFields": false,
    "AppConfig": true,
    "AppEcommerceManager": true,
    "AppScorePredictor": false,
    "AppSocialManager": true,
    "AppTicketingManager": true,
    "Blog": true,
    "BreakingNews": true,
    "Broadcasters": true,
    "BuildManager": true,
    "Calendar": true,
    "Clubs": true,
    "CustomCommentary": true,
    "CustomLineups": true,
    "CustomTables": true,
    "CustomTags": false,
    "Dashboard": true,
    "Docs": true,
    "Fixtures": false,
    "Forms": true,
    "HomepageManager": true,
    "HomepageNewsPromo": false,
    "HomepagePlayerHighlight": false,
    "Lab": true,
    "MatchdayTakeover": true,
    "Media": true,
    "News": true,
    "OptaIntegration": true,
    "Organisations": false,
    "OverlayPromos": true,
    "Pages": true,
    "PlatformOptions": true,
    "PlayerVoting": true,
    "PreventEntitlementEmails": false,
    "Profile": true,
    "RelatedContentTagging": true,
    "RewardsManager": false,
    "RewardPoints": false,
    "Rover": false,
    "Settings": false,
    "SiteConfig": true,
    "Sponsors": true,
    "Squads": true,
    "SsoUsers": true,
    "StreamAMGIntegration": false,
    "Streamline": true,
    "StreamlineAdverts": false,
    "StreamlinePromoCodes": false,
    "Videos": true,
    "Voice": false,
    "WebStats": true
}
